import { REFERRAL_MODAL_KEY } from "@constants";
import React from "react";
import { Dropdown } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";

export const ReferralModalTrigger: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();

    const triggerReferralModal = () => {
        setSearchParams(
            { ...searchParams, [REFERRAL_MODAL_KEY]: "true" },
            { replace: true },
        );
    };

    return (
        <Dropdown.Item
            onClick={triggerReferralModal}
            data-testid="refer-and-earn-button"
        >
            Refer &amp; earn
        </Dropdown.Item>
    );
};
